import React from 'react';
import { Label, Menu, Tab } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import _ from 'lodash'
import DeactivateAccountModal from '../Modal/deactivateAccountModal';
import ReactivateAccountModal from '../Modal/reactivateAccountModal';
import DeactivationLogModal from '../Modal/deactivationLogModal';
import CommonTable from '../../../../drive/Table/TableLayoutWithoutLocalFilter'
import AccountUserListJson from './AccountUserList.json';
import AccountUsersLIstEnterpriseAndPremium from './AccountUsersLIstEnterpriseAndPremium.json';
import AccountUserListFreemium from './AccountUserListFreemium.json';
import GrantPublicAccessModal from '../Modal/GrantPublicAccessModal';
import RevokePublicAccessModal from '../Modal/RevokePublicAccessModal';
import ManageIntegrationsModal from "../Modal/ManageIntegrationsModal";
export default class PlatformAccountsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tableHeader: AccountUserListJson,
            activeIndex: 0,
            _sort: 'createdAt',
            _limit: 10,
        }
        this.onTabChange = this.onTabChange.bind(this)
    }

    componentDidMount() {
        this.makePublicAccessButton(0)
    }

    handleDeactivateAccount = (open, data, actionType) => {
        this.setState({
            isDeactivateAccountModalOpen: open,
            accountData: data,
            actionType: actionType
        })
    }

    handleReactivateAccount = (open, data) => {
        let lastDeactivationLog = data && data.actionLogs && data.actionLogs.filter(log => {
            return log.action === 'deactivate'
        });

        this.setState({
            isReactivateAccountModalOpen: open,
            accountData: data,
            lastDeactivationLog: lastDeactivationLog && lastDeactivationLog[lastDeactivationLog.length - 1]
        })
    }

    closeReactivateAccountModal = (flag) => {
        this.setState({
            isReactivateAccountModalOpen: flag
        })
    }

    viewDeactivationLogs = (flag, data) => {
        this.setState({
            isDeactivateLogModalOpen: flag,
            accountData: data,
            actionLogs: data && data.actionLogs && data.actionLogs.reverse()
        })
    }

    addColumn = (newColumns) => {
        if (newColumns) {
            this.setState({ tableHeader: newColumns })
        }
    };

    handleDropDownItem = async (event, type, data, clickedCount) => {
        if (type.text === "View") {
            const history = this.props.history;
            await dispatch.app.setSingleAccountDetails(data)
            history.push({
                pathname: `/app/platform/home/${data._id}`
            });
        } else if (type.text === "Activate") {
            this.handleReactivateAccount(true, data)
        } else if (type.text === "Deactivate") {
            this.handleDeactivateAccount(true, data)
        } else if (type.text === "Account Logs") {
            this.viewDeactivationLogs(true, data)
        } else if (type.text === "Manage Integrations") {
            this.setState({ open: true, userdata: data });
        }
    }

    makePublicAccessButton = (activeIndex) => {
        if (activeIndex === 0) {
            this.setState({ tableHeader: AccountUserListFreemium })
        }
        else if (activeIndex === 1 || activeIndex === 2) {
            // let filterJson = this.state.tableHeader.filter(item => item.name !== "Make Public");
            this.setState({ tableHeader: AccountUserListJson })
        }
        
         else {
            this.setState({ tableHeader: AccountUsersLIstEnterpriseAndPremium })
        }
    }

    onTabChange(event, data) {
        this.makePublicAccessButton(data.activeIndex)
        this.setState({ activeIndex: data.activeIndex })
        setTimeout(() => {
            this.onQueryChange()
        }, 200);
    }


    onQueryChange = (query) => {
        if (query) {
            this.setState({ query: query })
        }
        setTimeout(() => {
            let payload = {
                query: this.state.query,
                planIndex: this.state.activeIndex
            }
            dispatch.platform.setSubscriptionsListQuery(payload);
            dispatch.platform.getAllAccountsWithOwnerDetails(payload)
        }, 200);
    };

    handleTableComponent = (event, item, data) => {
        event.stopPropagation();
        if (item.checked) {
            this.setState({ grantPublicAccessModalOpen: item.checked, accountData: data })
        }
        else {
            this.setState({ revokePublicAccessModalOpen: !item.checked, accountData: data })
        }

        // this.changeAccess(data, item);
    }
    handleGrantAccessModal = (value) => {
        this.setState({ grantPublicAccessModalOpen: value })
    }
    handleRevokeAccessModal = (value) => {
        this.setState({ revokePublicAccessModalOpen: value })
    }
    changeAccess = (data, item) => {
        let payload = {
            accountId: data._id,
            publicAccess: item.checked
        }
        dispatch.account.updatePublicAccess(payload)
    }
    onCloseManageIntegrationPopup = (open) => {
        this.setState({ open: open });
    };

    render() {
        let selectedAccount = this.props.allAccounts && this.props.allAccounts.data && this.state.userdata && this.props.allAccounts.data.filter(el=>el._id === this.state.userdata._id)
        let tabTables = <CommonTable
            tableName={null}
            tableHeader={this.state.tableHeader}
            listData={this.props.allAccounts && this.props.allAccounts.data}
            totalCount={this.props.allAccounts && this.props.allAccounts.total}
            loading={this.props.loaderForAllAccount}
            limit={this.state._limit}
            sort={this.state._sort}
            onQueryChange={this.onQueryChange}
            searchable={false}
            addColumn={this.addColumn}
            handleDropDownItem={this.handleDropDownItem}
            selection={true}
            handleTableComponent={this.handleTableComponent}
            activeIndex={this.state.activeIndex}
        />
        let basic = this.props.planCounts && this.props.planCounts.basic ? this.props.planCounts.basic : 0;
        let standard = this.props.planCounts && this.props.planCounts.standard ? this.props.planCounts.standard : 0;
        let premium = this.props.planCounts && this.props.planCounts.premium ? this.props.planCounts.premium : 0;
        let enterprise = this.props.planCounts && this.props.planCounts.enterprise ? this.props.planCounts.enterprise : 0;
        let freemium = this.props.planCounts && this.props.planCounts.free ? this.props.planCounts.free : 0;
        const panes = [
            {
                menuItem:
                    <Menu.Item key='Freemium'>
                        Freemium <Label>{freemium}</Label>
                    </Menu.Item>,
                render: () => tabTables
            },
            {
                menuItem:
                    <Menu.Item key='Basic'>
                        Basic <Label>{basic}</Label>
                    </Menu.Item>,
                render: () => tabTables
            },
            {
                menuItem:
                    <Menu.Item key='Standard'>
                        Standard <Label>{standard}</Label>
                    </Menu.Item>,
                render: () => tabTables
            },
            {
                menuItem:
                    <Menu.Item key='Premium'>
                        Premium <Label>{premium}</Label>
                    </Menu.Item>,
                render: () => tabTables
            },
            {
                menuItem:
                    <Menu.Item key='Enterprise'>
                        Enterprise <Label>{enterprise}</Label>
                    </Menu.Item>,
                render: () => tabTables
            }
        ]
        return (
            <div >
                <Tab
                    className="five-block"
                    style={{ padding: 0 }}
                    menu={{ secondary: true, pointing: true }}
                    panes={panes}
                    onTabChange={this.onTabChange}
                />

                <DeactivateAccountModal
                    isDeactivateAccountModalOpen={this.state.isDeactivateAccountModalOpen}
                    handleDeactivateAccount={this.handleDeactivateAccount}
                    account={this.state.accountData}
                />
                <GrantPublicAccessModal
                    grantPublicAccessModalOpen={this.state.grantPublicAccessModalOpen}
                    changeAccess={this.changeAccess}
                    account={this.state.accountData}
                    handleGrantAccessModal={this.handleGrantAccessModal}
                />
                <RevokePublicAccessModal
                    revokePublicAccessModalOpen={this.state.revokePublicAccessModalOpen}
                    changeAccess={this.changeAccess}
                    account={this.state.accountData}
                    handleRevokeAccessModal={this.handleRevokeAccessModal}
                />

                <ReactivateAccountModal
                    isReactivateAccountModalOpen={this.state.isReactivateAccountModalOpen}
                    handleReactivateAccount={this.handleReactivateAccount}
                    closeReactivateAccountModal={this.closeReactivateAccountModal}
                    account={this.state.accountData}
                    lastDeactivationLog={this.state.lastDeactivationLog}
                    user={this.props.user}
                />

                <DeactivationLogModal
                    isDeactivateLogModalOpen={this.state.isDeactivateLogModalOpen}
                    viewDeactivationLogs={this.viewDeactivationLogs}
                    account={this.state.accountData}
                    actionLogs={this.state.actionLogs}
                    user={this.props.user}
                />

                <ManageIntegrationsModal
                    open={this.state.open}
                    onCloseManageIntegrationPopup={this.onCloseManageIntegrationPopup}
                    // account={this.state.userdata}
                    account={selectedAccount && selectedAccount[0] }
                    // selectedAccount
                    integrationsList={this.props.integrationsList}
                    user={this.props.user}
                />
            </div>

        );
    }
}
